import { ReactElement } from "react";
import MainLayout from "../../ui/layouts/main/MainLayout";
import { composeServerSideProps } from "next-composition";
import { withBannersSearchSsrProps } from "../../server/ssrprops/withBannerSearchSsrProps";
import { withTranslations } from "../../server/ssrprops/withTranslations";
import { withStaticPageSsrProps } from "../../server/ssrprops/withStaticPageSsrProps";

import { LandingApplyLayout } from "../../ui/layouts/LandingApplyLayout/LandingApplyLayout";
import { useInitialStateFromQuery } from "../../hooks/useInitialStateFromQuery";
import { ContentRenderer } from "../../ui/components/ContentRenderer/ContentRenderer";
import { BannerSearchListResponseDataItem } from "../../api/content-client/service";

type PageProps = {
  bannersSearch: BannerSearchListResponseDataItem[];
  pageContent: {
    content: any[];
  };
  error?: boolean;
};

const StaticPage = (props: PageProps) => {
  const { bannersSearch, pageContent } = props;

  useInitialStateFromQuery();

  return (
    <>
      {pageContent?.content.filter(Boolean).map((block, index) => {
        return <ContentRenderer bannersSearch={bannersSearch} key={index} {...block} />;
      })}
    </>
  );
};

StaticPage.getLayout = (page: ReactElement, pageProps) => {
  const { pageContent } = pageProps;
  if (pageContent?.layout === "landing") {
    return <LandingApplyLayout>{page}</LandingApplyLayout>;
  }
  return <MainLayout> {page} </MainLayout>;
};

export const getServerSideProps = composeServerSideProps({
  use: [withBannersSearchSsrProps, withTranslations, withStaticPageSsrProps],
});

export default StaticPage;
